module.exports = __webpack_public_path__ + "static/img/total_best_team.bd4ae753.png";